export default __webpack_public_path__ + "static/media/co2Colored.7f45da52.png";